'use client';

import { cn } from '@/lib/utils';

export const LogoLoader = ({
  className = 'h-24 w-16',
}: {
  className?: string;
}) => {
  return (
    <div className="flex h-full animate-pulse items-center justify-center">
      <svg
        width="62"
        height="90"
        viewBox="0 0 62 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(className)}
      >
        <path
          d="M41.4967 10.5922C41.4967 4.52058 45.872 0 51.7484 0C57.6248 0 62 4.52058 62 10.5922C62 16.6638 57.6248 21.1844 51.7484 21.1844C45.872 21.1844 41.4967 16.6638 41.4967 10.5922Z"
          fill="#FF9900"
        />
        <path
          d="M45.3048 42.8852V75.2982H14.2034V42.8852H35.3867V28.1834H0V90H59.521V28.1834L45.3048 42.8852Z"
          fill="#004F5D"
        />
      </svg>
    </div>
  );
};
